import EA from '../helpers/init';

export default EA.Methods.playVideoLogic = ($this) => {
    const translations = window.coolinarikaConfig?.translations || {};
    const playLabel = translations['video.play'] || 'Play video';
    const pauseLabel = translations['video.pause'] || 'Pause video';
    const video = $this.querySelector('video');
    const playBtn = $this.querySelector('.start-stop');
    const circle = $this.querySelector('.progress-circle');

    if (!video || !playBtn || !circle) return;

    let animationId = null;

    const radius = 19;
    const circumference = 2 * Math.PI * radius;

    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference;

    playBtn.setAttribute('aria-label', playLabel);
    playBtn.setAttribute('aria-pressed', 'false');

    playBtn.addEventListener('click', () => {
        if (isPlaying(video)) {
            video.pause();
        } else {
            video.play();
        }
    });

    video.addEventListener('play', () => {
        cancelAnimationFrame(animationId);

        video.classList.add('played');
        playBtn.classList.add('is-playing');

        playBtn.setAttribute('aria-label', pauseLabel);
        playBtn.setAttribute('aria-pressed', 'true');

        animationId = requestAnimationFrame(updateProgress);
    });

    video.addEventListener('pause', () => {
        cancelAnimationFrame(animationId);

        video.classList.remove('played');
        playBtn.classList.remove('is-playing');

        playBtn.setAttribute('aria-label', playLabel);
        playBtn.setAttribute('aria-pressed', 'false');
    });

    video.addEventListener('ended', () => {
        resetVideo();
    });

    // forces video to stop and reset on end
    video.addEventListener('timeupdate', () => {
        if (video.duration && video.currentTime >= video.duration - 0.25) {
            resetVideo();
        }
    });

    function resetVideo() {
        cancelAnimationFrame(animationId);

        video.currentTime = 0;
        video.pause();

        video.classList.remove('played');
        playBtn.classList.remove('is-playing');

        playBtn.setAttribute('aria-label', playLabel);
        playBtn.setAttribute('aria-pressed', 'false');

        circle.style.strokeDashoffset = circumference;
    }

    function isPlaying(video) {
        return (
            video.currentTime > 0 &&
            !video.paused &&
            !video.ended &&
            video.readyState > 2
        );
    }

    function updateProgress() {
        if (!video.duration) return;

        const progress = video.currentTime / video.duration;
        circle.style.strokeDashoffset = circumference * (1 - progress);

        if (!video.paused && !video.ended) {
            animationId = requestAnimationFrame(updateProgress);
        }
    }
};
